// 000.000.000-00
export const maskCPF = (cpf: string) => {
  if (!cpf) {
    return '';
  }
  return cpf
    .replace(/\D/g, '')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d{1,2})/, '$1-$2')
    .replace(/(-\d{2})\d+?$/, '$1');
};

// SS.SSS.SSS/SSSS-NN  (S can be digit or letter, N only digits)
export const maskCNPJ = (cnpj: string) => {
  if (!cnpj) return '';
  const cleaned = cnpj.toUpperCase().replace(/[^0-9A-Z]/g, '');

  const part1 = cleaned.substring(0, 2);
  const part2 = cleaned.substring(2, 5);
  const part3 = cleaned.substring(5, 8);
  const part4 = cleaned.substring(8, 12);
  const part5 = cleaned.substring(12, 14);

  let result = '';
  if (part1) result += part1;
  if (cleaned.length > 2) result += `.${part2}`;
  if (cleaned.length > 5) result += `.${part3}`;
  if (cleaned.length > 8) result += `/${part4}`;
  if (cleaned.length > 12) result += `-${part5}`;

  return result;
};

// 000.000.000-00 or AA.AAA.AAA/AAAA-00
export const maskCPFOrCNPJ = (doc: string) => {
  if (!doc) {
    return '';
  }

  const hasLetters = /[A-Za-z]/.test(doc);
  const cleaned = doc.replace(/[\\.\-\\/\s]/g, '');
  const totalLength = cleaned.length;

  if (totalLength > 11 || hasLetters) {
    return maskCNPJ(doc);
  }

  return maskCPF(doc);
};

//* **.***.***-** or AA.AAA.AAA/AAAA-00
export const hideDocument = (doc: string) => {
  if (!doc) return '';

  const numbers = doc.replace(/\D/g, '');
  if (numbers.length === 11) return '***********'; // CPF

  return doc;
};

// (00) 00000-0000
export const maskPhone = (phone: string) => {
  if (!phone) {
    return phone;
  }

  return phone
    .replace(/\D/g, '')
    .replace(/^(\d{2})(\d)/g, '($1) $2')
    .replace(/(\d)(\d{4})$/, '$1-$2');
};

// 00000-000
export const maskCEP = (cep: string) => {
  if (!cep) {
    return '';
  }

  return cep
    .replace(/\D/g, '')
    .replace(/(\d{2})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1-$2')
    .replace(/(-\d{3})(\d+?)$/, '$1');
};

// 00/00/0000
export const maskDate = (date: string) => {
  if (!date) {
    return '';
  }
  return date
    .replace(/\D/g, '')
    .replace(/(\d{2})(\d)/, '$1/$2')
    .replace(/(\d{2})(\d)/, '$1/$2')
    .replace(/(\d{4})(\d)/, '$1');
};

export const unMaskFields = (value: string) => {
  if (!value) {
    return '';
  }
  return value.replace(/[^0-9A-Za-z]/g, '');
};

export type MaskTypes =
  | 'cpf'
  | 'cnpj'
  | 'cpf_cnpj'
  | 'cep'
  | 'date'
  | 'phone'
  | 'unMask'
  | 'hideDocument';

type Masks = Record<MaskTypes, (string: string) => string>;

const masks: Masks = {
  cpf: maskCPF,
  cnpj: maskCNPJ,
  cpf_cnpj: maskCPFOrCNPJ,
  cep: maskCEP,
  date: maskDate,
  phone: maskPhone,
  unMask: unMaskFields,
  hideDocument,
};

export default masks;
